export default "__VITE_ASSET__ZOO_hIU$__"